module.exports = __webpack_public_path__ + "static/img/rz(6).2001bd80.jpg";